import { createSlice } from '@reduxjs/toolkit'
import { uniq } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { RootState } from '../store'

// import { arrayDifference, hydrateMessage, uniqueArray } from '../utilities'

type SocketState = {
  eventQueue: any[]
  processing: any[]
  error: any
}

const initialState: SocketState = {
  eventQueue: [],
  processing: [],
  error: null
}

const socketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    addEvent: (state, { payload }) => {
      state.eventQueue.push({ ...payload, queueID: uuidv4() })
    },

    startProcessing: (state, { payload }) => {
      state.processing = uniq([...state.processing, payload])
    },

    clearEvent: (state, { payload }) => {
      state.eventQueue = state.eventQueue.filter(
        event => event.queueID !== payload.queueID
      )
    },

    failed: (state, { payload }) => {
      state.error = payload
    },

    clearError: state => {
      state.error = null
    }
  }
})

export const { addEvent, startProcessing, clearEvent, failed, clearError } =
  socketSlice.actions

export const selectSocket = (state: RootState) => state.socket

export default socketSlice.reducer
